import { createPortal } from "react-dom";

export default function Modal({ title, onClose, children, wide }) {
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4 sm:p-6" onClick={onClose}>
      <div
        data-testid="modal"
        className={`flex max-h-[calc(100vh-2rem)] w-full flex-col overflow-hidden rounded-lg border border-gray-300 bg-white shadow-[0_18px_44px_rgba(0,0,0,0.20)] sm:max-h-[calc(100vh-3rem)] ${wide ? "max-w-3xl" : "max-w-xl"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-gray-200 bg-gray-50 px-6 py-4">
          <h3 className="font-heading text-lg font-bold text-gray-950">{title}</h3>
          <button data-testid="modal-close" onClick={onClose} className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 bg-white text-xl leading-none text-gray-400 transition-colors duration-150 hover:border-gray-400 hover:text-gray-950" aria-label="Close modal">×</button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-6 py-5">{children}</div>
      </div>
    </div>,
    document.body
  );
}
